import { call, put } from 'redux-saga/effects'

import { sendAvailableProductsRequest } from "state/fetchSagas";
import * as appActions from "state/app/actions";

// Main Worker Saga
// started on FETCH_AVAILABLE_PRODUCTS (see ./index.js)
// also fired on first load by root saga to figure out what products we need to attach
export default function* fetchAvailableProductsSaga() {
    
  const response = yield call(sendAvailableProductsRequest);
  
  // if the user has no available applications, kick.
  if(response.data.length === 0) {
    yield put( appActions.forceRegistration("This device is no longer registered. Please re-register.") );

  // otherwise dispatch success normally
  } else {
    yield put( appActions.fetchAvailableProductsSuccess(response.data));
  }

}



// WEBPACK FOOTER //
// ./src/state/app/sagas/fetchAvailableProducts.js